// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3iQ5g","head":"Table_head__3eDpU","col":"Table_col__Qmuso"};